import { useSyncExternalStore } from 'react';
import { getDb, subscribeDb, type AppDatabase } from '../services/store';

/**
 * React-friendly hook that re-renders any component when the store changes.
 * Components should select narrowly to avoid unnecessary work, e.g.:
 *   const tournaments = useStore((db) => db.tournaments);
 */
export function useStore<T>(selector: (db: AppDatabase) => T): T {
  return useSyncExternalStore(
    subscribeDb,
    () => selector(getDb()),
    () => selector(getDb()),
  );
}
